export function formatInputAmount(raw: string, fractionDigits = 4, noLenLimit = false) {
  // replace dots to commas
  raw = raw.replace(/\,/g, '.');
  // remove non-numeric charsets
  raw = raw.replace(/[^0-9\.]/g, '');
  // allow only one leading zero
  raw = raw.replace(/^([0]+)/, '0');
  // prepend zero before leading comma
  raw = raw.replace(/^([\.]+)/, '0.');

  if (raw.substr(0, 1) === '0' && raw.substr(1, 1) !== '.' && raw.length > 1) {
    raw = raw.substr(1);
  }

  // allow only one comma
  let commaFound = false;
  raw = raw.replace(/\./g, () => {
    if (!commaFound) {
      commaFound = true;
      return '.';
    } else {
      return '';
    }
  });

  // apply length limitations
  const exp = raw.split('.');
  if (!noLenLimit) {
    exp[0] = exp[0].substr(0, 8);
  }
  if (fractionDigits <= 0) {
    return exp[0];
  }
  if (exp[1]) {
    exp[1] = exp[1].substr(0, fractionDigits);
  }

  return exp.join('.');
}

export function formatNumber(number: number, fractionDigits = 2) {
  return new Number(number).toPrecision(fractionDigits);
}

export function prettifyNumber(num) {
  if (num < 10000) {
    return num.toString();
  }

  return num.toLocaleString('en', { useGrouping: true }).replace(/,/g, ' ');
}

export function amountFractionDigits(currency?: string): number {
  switch ((currency || 'ton').toLowerCase()) {
    case 'place':
      return 0;
    case 'eur':
    case 'usd':
      return 2;
    case 'ton':
    default:
      return 3;
  }
}

export function toFiniteNumber(value: number | string): number {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
}

export type FormatAmountOptions = {
  symbol?: boolean;
  fractionDigits?: number;
};

export function formatAmount(
  amount: number | string,
  currency = 'ton',
  { symbol = true, fractionDigits }: FormatAmountOptions = {},
): string {
  const cur = (currency || 'ton').toLowerCase();
  const digits = fractionDigits ?? amountFractionDigits(cur);
  const value = toFiniteNumber(amount);

  let formatted = new Intl.NumberFormat('en-US', {
    useGrouping: cur === 'place',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

  formatted = formatted.replace(/,/g, ' ');

  if (formatted === '-0' || /^-0(?:\.0+)?$/.test(formatted)) {
    formatted = formatted.slice(1);
  }

  return symbol ? `${formatted} ${cur.toUpperCase()}` : formatted;
}
